import { CHECK_FILE_ERROR, CHECK_FILE_POST_ERROR, CHECK_FILE_SUCCESS } from "../actions/types";

export default (state = {  
    error: null,
    files:[],
}, action) => {
    switch (action.type) {
        case CHECK_FILE_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: action.payload,
            };
            break;
        case CHECK_FILE_SUCCESS:
            return {
                ...state,
                error: state.error,
                loading:false,
                files: action.payload,
            };
            break;
        case CHECK_FILE_POST_ERROR:
            return {
                ...state,
                error: state.error,
                loading:false,
                success: action.payload,
            };
            break;
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/reducers/checkFileStatusReducer.js